module.exports = __webpack_public_path__ + "static/media/dsync_integration.6f488ac7.svg";